<script setup>
import { reactive, ref } from "vue";
import QuestionsComponent from "./QuestionsComponent.vue";
import NameAndFilesComponent from "./NameAndFilesComponent.vue";
import api from "@/api/index.js";

const form = reactive({
	name: "",
	email: "",
	phone: "",
	cv: null,
	task: null,

	questions: "",
	experience: "",
	build: "",
	rules: false,
	self_withdrawl: false,
	no_outside_help: false,
});
const loading = ref(false);

async function submitForm() {
	loading.value = true;
	const formData = new FormData();

	formData.append("name", form.name);
	formData.append("email", form.email);
	formData.append("phone", form.phone);
	formData.append("questions", form.questions);
	formData.append("experience", form.experience);
	formData.append("build", form.build);
	formData.append("rules", form.rules ? "1" : "0");
	formData.append("self_withdrawl", form.self_withdrawl ? "1" : "0");
	formData.append("no_outside_help", form.no_outside_help ? "1" : "0");

	if (form.cv) formData.append("cv", form.cv);
	if (form.task) formData.append("test", form.task);

	try {
		const res = await api.postApplication(formData);

		console.log("Application sent:", res.data);
		alert("success");
	} catch (error) {
		console.error("Failed to send application:", error);
		console.log("URL:", error.config.baseURL + error.config.url);
		console.log("STATUS:", error.response?.status);
		console.log("RESPONSE:", error.response?.data);
	} finally {
		loading.value = false;
	}
}
</script>

<template>
	<form class="form" @submit.prevent="submitForm">
		<NameAndFilesComponent v-model="form" />
		<QuestionsComponent v-model="form" />

		<button type="submit" class="submit-btn" :disabled="loading">
			{{ loading ? "Sending..." : "Submit application" }}
		</button>
	</form>
</template>

<style lang="scss" scoped>
@use "@/assets/css/vars" as *;

.form {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	background-color: $background-color-f5;
	gap: 64px;
	width: 100%;
	padding: 80px 400px;
}

.submit-btn {
	height: $button-height;
	border-radius: $button-border-radius;
	background: $app-color;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 35px;
	color: $text-white;
	font-family: $font-main;
	font-weight: $font-semibold;
	font-size: $text-md;
	border: none;
	cursor: pointer;
	transition: opacity 0.2s ease;

	&:hover {
		opacity: 0.9;
	}

	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}
}

@media screen and (max-width: 1200px) {
	.form {
		padding: 60px 80px;
	}
}

@media screen and (max-width: 768px) {
	.form {
		gap: 40px;
		padding: 40px 24px;
	}
}

@media screen and (max-width: 480px) {
	.form {
		padding: 32px 16px;
	}

	.submit-btn {
		width: 100%;
	}
}
</style>
